 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import ms from 'ms'
import {useEffect} from 'react'
import {useLazyLoadQuery} from 'react-relay'
import { useHistory} from 'react-router'

import SendClientSideEvent from '../utils/SendClientSideEvent'


import useAtmosphere from './useAtmosphere'

const NAG_EVERY = ms('3m')

const getIsNaggingPath = (history) => {
  const {location} = history
  const {pathname} = location
  return !(pathname.includes('/usage') || pathname.includes('/meet/'))
}

const shouldNag = (billingTier, suggestedTier) => {
  if (!suggestedTier) return false
  const suggestPro = suggestedTier === 'team' && billingTier === 'starter'
  const suggestEnterprise = suggestedTier === 'enterprise' && billingTier !== 'enterprise'
  return suggestPro || suggestEnterprise
}

const emitNag = (atmosphere, history) => {
  atmosphere.eventEmitter.emit('addSnackbar', {
    key: 'usage',
    message: 'View your usage stats',
    autoDismiss: 0,
    onDismiss: () => {
      setTimeout(() => {
        const isNaggingPath = getIsNaggingPath(history)
        if (!isNaggingPath) return
        emitNag(atmosphere, history)
      }, NAG_EVERY)
    },
    action: {
      label: 'View Usage',
      callback: () => {
        atmosphere.eventEmitter.emit('removeSnackbar', ({key}) => key === 'usage')
        history.push(`/usage`)
        SendClientSideEvent(atmosphere, 'Clicked usage snackbar CTA')
      }
    }
  })
  SendClientSideEvent(atmosphere, 'Sent usage snackbar')
}

const useUsageSnackNag = (insights) => {
  const atmosphere = useAtmosphere()
  const history = useHistory()
  const isNaggingPath = getIsNaggingPath(history)
  const isUserNaggable = isNaggingPath && insights
  const {viewer} = useLazyLoadQuery(
    graphql`
      query useUsageSnackNagQuery($isUserNaggable: Boolean!) {
        viewer {
          domains @include(if: $isUserNaggable) {
            tier
            suggestedTier
            organizations {
              tierLimitExceededAt
            }
          }
        }
      }
    `,
    {isUserNaggable}
  )

  const {domains} = viewer

  // Do not use snack nag if the user has an organization with the limit exceeded, in this case we use a different warnings approach
  const limitExceeded = _optionalChain([domains, 'optionalAccess', _ => _.find, 'call', _2 => _2(({organizations}) =>
    organizations.find(({tierLimitExceededAt}) => !!tierLimitExceededAt)
  )])

  const nag =
    !limitExceeded && _optionalChain([domains, 'optionalAccess', _3 => _3.find, 'call', _4 => _4(({tier, suggestedTier}) => shouldNag(tier, suggestedTier))])
  useEffect(() => {
    if (!nag) return
    emitNag(atmosphere, history)
  }, [nag])
}

export default useUsageSnackNag
